import { render, staticRenderFns } from "./MonitoringBussinessProcceses.vue?vue&type=template&id=26479ec1&scoped=true&"
import script from "./MonitoringBussinessProcceses.vue?vue&type=script&lang=ts&"
export * from "./MonitoringBussinessProcceses.vue?vue&type=script&lang=ts&"
import style0 from "./MonitoringBussinessProcceses.vue?vue&type=style&index=0&id=26479ec1&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26479ec1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VExpansionPanels,VRow})
